var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu_block"},[_c('div',{staticClass:"menu_list"},[_c('div',{staticClass:"menu"},[_c('ul',_vm._l((_vm.navigationItems),function(item,index){return _c('navigation-menu-item',{key:index,attrs:{"item":item}})}),1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }